import { render } from "./LayoutContent3Cols.vue?vue&type=template&id=5bbe17b6&scoped=true"
import script from "./LayoutContent3Cols.vue?vue&type=script&lang=js"
export * from "./LayoutContent3Cols.vue?vue&type=script&lang=js"

import "./LayoutContent3Cols.vue?vue&type=style&index=0&id=5bbe17b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbe17b6"]])

export default __exports__